import React, { useEffect, useState } from "react";
import { Modal, Form,message, Input, Select, Table, Button } from "antd";
import vendorRequest from "../VendorRequest";


export const AddVendorAmount = ({
  form,
  isModalOpen,
  handleCancel,
  setFilterForm,
  filterForm,
  vendorId,
  handleFilter,
  hndl,
  tableData, // Pass table data as a prop
  availableBalance // Pass available balance as a prop // Function to handle form submission for adding money
}) => {
  const payload = {
    UserId : vendorId,
    pageNo: 1,
    pageSize: 5
  };
const [loading, setLoading] = useState(false);
const [filteredUsers, setFilteredUsers] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [Balance, setBalance] = useState(availableBalance);
  
  const [filter, setFilter] = useState(payload);


  

  const handleChange = (pagination) => {
    setFilter({ ...filter, pageNo: pagination?.current });

  };

  const handleAddMoney = (values) => {
    // setLoading(true);
    console.log("Requested");
    const vendoramount = {
      UserId : vendorId,
      amount : values.amount,
      transactionType : values.transactionType, 
      remark : "ByAdmin"

      
    };
    
    AddVendorAmount(vendoramount);
   
    console.log("Add Money values:", vendoramount);
  };

  const AddVendorAmount = (values) => {
    setLoading(true);
    vendorRequest
      .addVendorWalletAmount(values)
      .then((response) => {
        console.log("Add Money response:", response);
        message.success("Amount "+ values.transactionType +" Successfully");
        form.resetFields();
        fetchUserFilterList();
        hndl();
        console.log("Balance response:", response.data?.data);
        setBalance(response.data?.data);
        // const rawData = response?.data?.data?.data || [];
        // const totalCount = response?.data?.data?.totalItems || 0;
        // console.log("Fetched vendor response:", response);
        // console.log("Fetched vendor details:", rawData);
        // console.log("Total Count:", totalCount);
        // // setLabList(rawData);
        // setFilteredUsers(rawData);
        // setTotalRecords(totalCount);
      })
      .catch((error) => {
        message.error("Failed to Credit/Debit amount.");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const fetchUserFilterList = () => {
    setLoading(true);
    vendorRequest
      .getVendorWalletList(filter)
      .then((response) => {
        const rawData = response?.data?.data?.data || [];
        const totalCount = response?.data?.data?.totalItems || 0;
        console.log("Fetched vendor response:", response);
        console.log("Fetched vendor details:", rawData);
        console.log("Total Count:", totalCount);
        // setLabList(rawData);
        setFilteredUsers(rawData);
        setTotalRecords(totalCount);
      })
      .catch((error) => {
        message.error("Failed to fetch users.");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (vendorId) {
      // Call API to fetch vendor details using the vendorId
      console.log("Fetching details for vendor ID:", vendorId);
      // Example API call:
      // fetchVendorDetails(vendorId).then((response) => {
      //   console.log("Vendor Details:", response);
      // });
      
      
      fetchUserFilterList();
    }
  }, [vendorId,filter]);
  // Define columns for the table
  const columns = [
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Remark",
      dataIndex: "remark",
      key: "remark",
    },
    {
      title: "Type",
      dataIndex: "transactionType",
      key: "transactionType",
      render: (transactionType) => (
        <span
        style={{
          color: transactionType.toLowerCase() === "credit" ? "green" : "red",
        }}
      >
        {transactionType.toLowerCase() === "credit" ? "Credit" : "Debit"}
      </span>
      ),
    },
    {
      title: "Transaction Date",
      dataIndex: "transactionDate",
      key: "transactionDate",
    },
    // {
    //   title: "Status",
    //   dataIndex: "isActive",
    //   key: "isActive",
    //   render: (isActive) => (isActive ? "Active" : "Inactive"),
    // },
  ];



  return (
    <Modal
      title="Add Money"
      open={isModalOpen}
      onOk={handleFilter}
      // okText="Filter Data"
      onCancel={handleCancel}
      width={800}
    >
      {/* Add Money Form */}
      <Form
        form={form}
        layout="vertical"
        onFinish={handleAddMoney} // Handle form submission
        style={{ marginBottom: "20px" }}
      >
        <Form.Item label="Available Balance">
          <Input value={`₹ ${Balance}`} disabled />
        </Form.Item>
        <Form.Item
          name="amount"
          label="Amount"
          rules={[{ required: true, message: "Please enter an amount" }]}
        >
          <Input type="number" placeholder="Enter amount" />
        </Form.Item>
        <Form.Item
          name="transactionType"
          label="Transaction Type"
          rules={[{ required: true, message: "Please select a transaction type" }]}
        >
          <Select placeholder="Select Credit/Debit">
            <Select.Option value="credit">Credit</Select.Option>
            <Select.Option value="debit">Debit</Select.Option>
          </Select>
        </Form.Item>
        <Button type="primary" htmlType="submit" block>
          Add Money
        </Button>
      </Form>

      

      {/* Table */}
      <Table
        columns={columns}
        dataSource={filteredUsers}
        onChange={handleChange}
        rowKey={(record) => record.id} // Ensure each row has a unique key
        loading={loading}
        size="middle"
        pagination={{
          total: totalRecords,
          current: filter?.pageNo || 0,
          defaultCurrent: 1,
          pageSize: 5, // Set the number of records per page
        }}
        // loading={loading}

      />
    </Modal>
  );
};